import { useEffect, useState } from 'react';
import { PieChart } from '@/common/dashboard/charts/PieChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';


export const McdInvPriorQtrPercentCompleteChart = ({ selectedStates = [], selectedPeriod, selectedCtrts = [], selectedDueDate }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();
  const [centerLabel, setCenterLabel] = useState();

  // const data = [
  //   { label: 'Not Ready', color: '#d36b6dff', value: 10 },
  //   { label: 'In Progress', color: '#f7f35bff', value: 6 },
  //   { label: 'Settled', color: '#73c45fff', value: 5 },
  // ];

  // const centerLabel = 'Not Ready: 10<br>In Progress: 6<br>Settled: 5<br><b>Total: 21</b>';


  useEffect(() => {
    if (!selectedPeriod?.id) {
      return;
    }

    const stateIds = selectedStates.map(state => state.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const reqParam = {
      periodId: selectedPeriod?.id,
      stateIds,
      ctrtIds,
      dueDate: selectedDueDate?.value
    };

    rsrc.data('sc', 'MCD_PRIOR_QTR_PERCENT_COMPLETE_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
      let totalCount = 0;

      let notReadyData = data[0];
      let notReadyCount = notReadyData.value;
      totalCount += notReadyCount;
      let centerLabel = 'Not Ready: ' + notReadyCount + '<br>';

      let inProgressData = data[1];
      let inProgressCount = inProgressData.value;
      totalCount += inProgressCount;
      centerLabel += 'In Progress: ' + inProgressCount + '<br>';

      let paidData = data[2];
      let paidCount = paidData.value;
      totalCount += paidCount;
      centerLabel += 'Paid: ' + paidCount + '<br>';

      centerLabel += '<br><b>Total: ' + totalCount + '</b>';

      setCenterLabel(centerLabel);
    });
  }, [selectedStates, selectedPeriod, selectedCtrts, selectedDueDate]);

  if (!data) return null;

  return (
    <PieChart
      centerLabel={centerLabel}
      data={data}
    />
  );
};
